import { CircularProgress } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledCircularProgress = styled(CircularProgress)(({ theme }) => ({
  position: "absolute",
}));
